import React from "react";
import { useNavigate } from "react-router-dom";

export default function Forbidden() {
  const navigate = useNavigate();

  return (
    <div className=" flex h-[100vh] w-full items-center justify-center px-2">
      <div className="text-center  text-orange-400 mb-12 px-4 md:px-20 border shadow-2xl shadow-orange-600 p-6 border-orange-400 rounded-2xl">
        <p className="font-extrabold text-3xl">دسترسی غیر مجاز</p>
        <p className="mt-6">
          شما دسترسی لازم برای انجام عملیات موردنظر را ندارید <br/>
          برای اطلاعات بیشتر با ادمین سامانه تماس بگیرید
        </p>
        <button onClick={()=>navigate("/")}
                className="mt-12 p-3 px-4 font-extrabold text-sm rounded-xl text-teal-800 bg-teal-100 border border-teal-700 shadow-sm transition-all duration-300 shadow-teal-600 hover:bg-teal-800 hover:text-teal-200">
           بازگشت به صفحه اصلی
           </button>
      </div>
    </div>
  );
}
